import React from 'react';
import { useStreamerMode } from '../contexts/StreamerModeContext';

interface BlurredAmountProps {
  amount: string | number;
  className?: string;
  formatter?: (amount: string | number) => string;
  formatCurrency?: boolean;
  children?: React.ReactNode;
}

const BlurredAmount: React.FC<BlurredAmountProps> = ({ 
  amount, 
  className = '', 
  formatter,
  formatCurrency: shouldFormatCurrency = false,
  children 
}) => {
  const { isStreamerMode } = useStreamerMode();
  
  const formatCurrency = (amount: string | number) => {
    const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount;
    return new Intl.NumberFormat('ru-RU', {
      style: 'currency',
      currency: 'RUB',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(numAmount);
  };

  const displayValue = formatter 
    ? formatter(amount) 
    : shouldFormatCurrency 
    ? formatCurrency(amount) 
    : amount.toString();

  return (
    <span 
      className={`${className} ${isStreamerMode ? 'select-none' : ''} transition-all duration-300`}
      style={{
        filter: isStreamerMode ? 'blur(8px)' : 'none',
        userSelect: isStreamerMode ? 'none' : 'auto'
      }}
    >
      {children || displayValue}
    </span>
  );
};

export default BlurredAmount;